import React from "react";
import Card from "../../common/Card";
import { Certificate, GraduationCap, TreeView } from "@phosphor-icons/react";

const Interests = () => {
    return <Card title={"الاهتمامات"} icon={<TreeView size={32} />}></Card>;
};

export default Interests;
